import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
  getAllGroups,
  getFactoryByGroupID,
  getOpeningClosingforPnLRTFDetails,
  getProfitAndLossRTFDetails,
  saveInventoryBalance,
  GetCopReportDetails
};


async function getAllGroups() {
  let response = await CommonGet('/api/Group/GetAllGroups');
  let groupArray = [];
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true) {
      groupArray[item[1]["groupID"]] = item[1]["groupName"];
    }
  }
  return groupArray;
};

async function getFactoryByGroupID(groupID) {
  let response = await CommonGet('/api/Group/GetFactoryByGroupID', "groupID=" + parseInt(groupID));
  let factoryArray = [];
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
  }
  return factoryArray;
};

async function getOpeningClosingforPnLRTFDetails(model) {
  let response = await CommonPost('/api/ProfitAndLossReportRTF/getOpeningClosingforPnLRTFDetails', null, model);
  return response;
}

async function GetCopReportDetails(dayWiseCropDetailsModel) {
  let response = await CommonPost('/api/COPReport/GetCOPReport2Details', null, dayWiseCropDetailsModel);
  return response;
}

async function saveInventoryBalance(inventoryModel) {
  let response = await CommonPost('/api/ProfitAndLossReportRTF/saveInventoryBalance', null, inventoryModel);
  return response;
}

async function getProfitAndLossRTFDetails(model) {
  let response = await CommonPost('/api/ProfitAndLossReportRTF/GetProfitAndLossRTFDetails', null, model);
  return response;
}